module.exports = __webpack_public_path__ + "img/npxxx.3baa3e8b.png";